import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initStore from './stores';
import { BrowserRouter } from 'react-router-dom';
import { Spin } from 'antd';

const stores = initStore();

ReactDOM.render(
  <React.StrictMode>
    <Provider {...stores}>
      <React.Suspense fallback={<Spin className="center-spin" />}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Suspense>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
